var _rect, _rect2, _g, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFantasyFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    width: 640,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#1b5e20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 560,
    height: 300,
    fill: "#2e7d32",
    stroke: "#fafafa",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fafafa",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 30,
    x2: 96,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 30,
    x2: 152,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208,
    y1: 30,
    x2: 208,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 30,
    x2: 264,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 30,
    x2: 320,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376,
    y1: 30,
    x2: 376,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 30,
    x2: 432,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 488,
    y1: 30,
    x2: 488,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544,
    y1: 30,
    x2: 544,
    y2: 330
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 180,
    rx: 36,
    ry: 22,
    fill: "#6d4c41",
    stroke: "#efebe9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 180 h40",
    stroke: "#efebe9",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308 172 v16 M320 170 v20 M332 172 v16",
    stroke: "#efebe9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasyFootball);
export default __webpack_public_path__ + "static/media/fantasyFootball.1ff40661ff1de72b5e75c00959833a6a.svg";
export { ForwardRef as ReactComponent };